<template>
  <div class="recommendProducts">
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="item.skuid">
        <div class="productInfo flex-ac">
          <van-checkbox
            @change="choice(item)"
            checked-color="#FC0324"
            v-model="item.ischoose"
          ></van-checkbox>
          <img :src="item.img_path" @click.stop="goProductDetail(item.itemid)" />
          <div class="rightBox" @click.stop="goProductDetail(item.itemid)">
            <p class="name">{{ item.name }}</p>
            <p class="sku">
              <span @click.stop="openSku(index, item)">
                {{ item.spec }}
                <van-icon name="arrow-down" color="#6c6c6c" />
              </span>
            </p>
            <div class="flex-js-ac mt18">
              <p class="currentPrice">¥{{ item.sales_price }}</p>
              <div class="stepBox flex-js-ac">
                <div
                  :class="[item.num <= 0 ? 'can' : '', 'subtract stepBtn']"
                  @click.stop="addToCart(0, index, item)"
                ></div>
                <div class="num">{{ item.num }}</div>
                <div class="add stepBtn can" @click.stop="addToCart(1, index, item)"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="act_desc_tag"
          v-if="
            parseInt(item.ispresale) == 1 ||
              parseInt(item.isdiscount) == 1 ||
              parseInt(item.isfullgift) == 1 ||
              parseInt(halfprice.halfpricestatus) == 1
          "
          @click="showActDesc(item)"
        >
          <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.ispresale) == 1">
            预售
          </van-tag>
          <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isdiscount) == 1">
            {{ discountrule.actlabel }}
          </van-tag>
          <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isfullgift) == 1">
            {{ fullgiftrule.actlabel }}
          </van-tag>
          <van-tag
            color="#FEE9E6"
            text-color="#F12A0E"
            v-if="parseInt(halfprice.halfpricestatus) == 1 && item.ishalf == 1"
          >
            {{ halfprice.halfactlabel }}
          </van-tag>
          <van-icon name="arrow" />
        </div>
        <div class="act_desc_time" v-if="parseInt(item.ispresale) == 1">
          <img src="../../assets/images/presell.png" />
          <div class="txt">预售发货时间：{{ item.presaletime }}</div>
        </div> -->
      </div>
    </div>
    <div class="btnBox flex-js-ac">
      <div class="flex-ac">
        <div class="flex-ac">
          <van-checkbox
            v-model="allChoiceFlag"
            checked-color="#FC0324"
            @click="Allchoice()"
          ></van-checkbox>
          <span class="ml10">全选</span>
        </div>
        <div class="ml20">
          <p>
            <span>合计:</span>
            <span class="f16 fb color-red">¥{{ parseFloat(totalMoney).toFixed(2) }}</span>
          </p>
          <div class="flex-ac">
            <p class="oldTotalMoney">¥{{ parseFloat(oldTotalMoney).toFixed(2) }}</p>
            <!-- <p class="flex-ac" @click="showofferdetails = true">
              <span class="discountLabel color-red">优惠明细</span>
              <img class="foldBtn" src="../../assets/images/upred.png" />
            </p> -->
          </div>
        </div>
      </div>
      <div class="submitBtn" @click="submit">
        去结算{{ totalNumber ? '(' + totalNumber + ')' : '' }}
      </div>
    </div>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :goods-id="productId"
      :quota="maxNum"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
            </div>
          </div>
        </div>
      </template>
      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <!-- 优惠明细 -->
    <div class="discountWrap">
      <van-action-sheet
        v-model="showofferdetails"
        title="优惠明细"
        class="offer"
        close-on-click-overlay
      >
        <div class="offerdetailsdis">
          <div class="ofd1">*实际优惠金额以下单页为准</div>
          <div class="discountList">
            <div class="item goodstotalprice">
              <div class="tit">商品总额</div>
              <div class="value">¥{{ parseFloat(countTotalMoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="fullDiscountmoney">
              <div class="tit">{{ fullDiscountRule.actlabel }}</div>
              <div class="value">-¥{{ parseFloat(fullDiscountmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="discountrule.discountenable == 1">
              <div class="tit">{{ discountrule.name }}</div>
              <div class="value">-¥{{ parseFloat(discounmoney).toFixed(2) }}</div>
            </div>
            <div class="item combined">
              <div class="tit">合计</div>
              <div class="value">¥{{ parseFloat(totalMoney).toFixed(2) }}</div>
            </div>
            <div class="item desc">
              <div class="tit">(未计算运费、现金券、金币，请在下单页查看)</div>
            </div>
          </div>
        </div>
      </van-action-sheet>
    </div>

    <!--活动服务-->
    <div class="presale_info_dialog" v-if="showPresale == true">
      <div class="dialog">
        <div class="header">
          <div class="van-divider">预售购买</div>
        </div>
        <div class="content">
          {{ presaledescpt }}
        </div>
        <div class="btn" @click="presell">我知道了</div>
      </div>
    </div>
    <!--活动服务-->
    <van-action-sheet v-model="showaction" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div class="tit">
            <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
            {{ item.name }}
          </div>
          <div class="con" v-if="item.statusmsg">
            {{ item.statusmsg }}
          </div>
          <div class="con">
            {{ item.desc }}
          </div>
        </div>
        <div class="btn">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  isWeixin,
  fenxiang,
  basepath,
  Base64,
  before_addOrder
} from '../../assets/common/js/config'
import { Divider, Checkbox, CheckboxGroup, Stepper, Sku, Tag, Overlay } from 'vant'
export default {
  name: 'productList',
  components: {
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Stepper.name]: Stepper,
    [Sku.name]: Sku,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      list: null, // 收单列表
      totalNumber: 0, // 已勾选商品数量
      totalMoney: 0, // 合计金额
      oldTotalMoney: 0, // 原价总金额
      countTotalMoney: 0, // 优惠前金额
      allChoiceFlag: 1,
      showsku: false,
      showPresale: false,
      presaledescpt: null,
      showaction: false,
      msglist: null,
      discountrule: {},
      FlodMsg: null,
      currentdiscount: 0,
      fullgiftrule: {},
      showofferdetails: false,
      sku: {
        tree: [],
        list: [],
        price: 0,
        stock_num: 0,
        collection_id: 0,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '商品',
        picture: ''
      },
      productId: null,
      maxNum: null,
      customStepperConfig: {
        quotaText: '限购',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            let msg = `数量超出范围~`
            this.$toast(msg)
            // console.log(limitType)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      skuname: '',
      skuprice: '0',
      sureGray: false,
      initialSku: {},
      discounmoney: 0,
      goodsnum: 0,
      halfprice: {},
      fullDiscountRule: {}, // 限时折扣
      fullDiscountmoney: 0
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    if (isWeixin()) fenxiang({ path: 'beautityproductList' })
  },
  methods: {
    // 获取商品列表
    getList() {
      let itemids, url
      itemids = this.$route.query.itemids
      url = this.$ajax.getGoodsList_URL + '?itemids=' + itemids
      try {
        this.$customRequestAjax(url)
          .then((res) => {
            if (res.data.code === 200) {
              let list = res.data.cartlist
              if (sessionStorage.getItem('recommendProducts_fullgift_product')) {
                let fullgift_product = JSON.parse(
                  sessionStorage.getItem('recommendProducts_fullgift_product')
                )
                list = list.concat(fullgift_product)
              }
              this.presaledescpt = res.data.presaledescpt
              list.map((item) => {
                let indexWh = 0,
                  indexDs = 0
                item.ischoose = 1
                item.sku_rule_list.map((itemSon) => {
                  itemSon.temp_sales_price = itemSon.sales_price
                  if (
                    itemSon.canbuycnt <= 0 ||
                    itemSon.islimit == 2 ||
                    itemSon.issale == 0 ||
                    item.is_can_buy == 0
                  ) {
                    indexWh++
                  }
                  if (itemSon.islimit == 1) {
                    indexDs++
                  }
                  if (
                    item.sku_rule_list &&
                    item.sku_rule_list.length <= indexWh &&
                    item.sku_rule_list.length > indexDs
                  ) {
                    item.inventory = 0 // 无货状态
                  } else {
                    item.inventory = 1 // 有货状态
                  }
                  if (
                    item.islimit != 0 ||
                    parseInt(item.canbuycnt) <= 0 ||
                    item.issale == 0 ||
                    item.is_can_buy == 0
                  ) {
                    item.ischoose = 0
                  }
                })
              })
              this.list = list
              // this.discountrule = res.data.discountrule
              // this.fullgiftrule = res.data.fullgiftrule
              // this.fullDiscountRule = res.data.fullDiscountRule || {}
              // this.halfprice = {
              //   halfpricestatus: res.data.halfpricestatus,
              //   halfpricedesc: res.data.halfpricedesc,
              //   halfactname: res.data.halfactname,
              //   halfactlabel: res.data.halfactlabel
              // }
              this.count()
            } else {
            }
          })
          .catch((err) => {})
      } catch (e) {}
    },
    presell() {
      this.showPresale = false
      // this.settlement()
    },
    showActDesc: function(obj) {
      this.msglist = []

      if (
        this.discountrule &&
        this.discountrule.discountenable == 1 &&
        this.discountrule.discountlist &&
        obj.isdiscount == 1
      ) {
        let msg = [],
          discountruledesc

        this.discountrule.discountlist.forEach(function(item) {
          let txt =
            (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
          msg.push(item.itemnum + '件' + txt + '折')
        })

        discountruledesc = '满' + msg.join(',')
        this.msglist.push({
          enable: this.discountrule.discountenable,
          shortdesc: discountruledesc,
          desc: this.discountrule.discountdescription,
          name: this.discountrule.name,
          actlabel: this.discountrule.actlabel,
          statusmsg: '参与活动商品享受折上折优惠'
        })
      }
      if (
        this.fullgiftrule &&
        this.fullgiftrule.actstatus == 1 &&
        this.fullgiftrule.rulelist &&
        obj.isfullgift == 1
      ) {
        this.msglist.push({
          enable: this.fullgiftrule.actstatus,
          shortdesc: this.fullgiftrule.actdesc,
          desc: this.fullgiftrule.actdesc,
          name: this.fullgiftrule.actname,
          actlabel: this.fullgiftrule.actlabel
        })
      }

      if (this.halfprice.halfpricestatus == 1 && obj.ishalf == 1) {
        this.msglist.push({
          enable: this.halfprice.halfpricestatus,
          shortdesc: this.halfprice.halfpricedesc,
          desc: this.halfprice.halfpricedesc,
          name: this.halfprice.halfactname,
          actlabel: this.halfprice.halfactlabel
        })
      }
      this.showaction = true
    },
    // 跳转至商品详情
    goProductDetail(itemid) {
      this.$app.goItemDetail(itemid, { beautitysaidid: this.$route.query.beautitysaidid })
    },
    updateProduct: function(data, fn) {
      fn()
    },
    // 打开sku选项卡
    openSku(index, item) {
      let that = this
      if (item.inventory != 1) {
        return
      }
      this.productNum = item.num
      this.listItem = item
      this.itemIndex = index
      this.productId = this.listItem.itemid
      this.maxNum = parseInt(this.listItem.canbuycnt)
      this.goods.title = item.name
      this.skuprice = parseFloat(item.sales_price).toFixed(2)
      this.goods.picture = item.img_path
      this.skuname = item.spec
      this.sku.tree = []
      this.sku.list = []

      this.listItem.normlist.map(function(item, index) {
        that.sku.tree.push({
          k: item.spec_classify_name,
          v: [],
          k_s: 's' + (index + 1)
        })
        item.speclist.map(function(itemSon) {
          that.sku.tree[index].v.push({
            id: itemSon.spec_id,
            name: itemSon.spec_name
          })
        })
      })
      this.listItem.sku_rule_list.map(function(item) {
        var stockNum =
          item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 || item.is_can_buy == 0
            ? 0
            : parseInt(item.canbuycnt)
        that.sku.list.push({
          id: item.skuid,
          price: parseFloat(item.sales_price).toFixed(2),
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          stock_num: stockNum,
          islimit: item.islimit,
          issale: item.issale,
          cost_price: item.cost_price,
          temp_sales_price: parseFloat(item.sales_price).toFixed(2)
        })
        if (item.skuid == that.listItem.skuid) {
          that.initialSku = {
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            selectedNum: parseInt(item.num),
            cost_price: item.cost_price,
            temp_sales_price: parseFloat(item.sales_price).toFixed(2)
          }
        }
      })
      this.showsku = true
    },
    checkedSku(skuValue) {
      if (!skuValue.selectedSkuComb) {
        this.sureGray = true
      } else {
        this.sureGray = false
      }
      var skuStr = ''
      this.skuname = ''
      var len = this.listItem.sku_rule_list
      var skuIndex = 0
      var index = 0
      Object.keys(skuValue.selectedSku).forEach(function(key) {
        skuIndex++
        if (skuValue.selectedSku[key] != '') {
          skuStr =
            skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
          index++
        }
      })
      if (index == skuIndex) {
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_group_id == skuStr) {
            this.skuname = len[i].sku_name
            this.goods.picture = len[i].spec_imgpath
            if (skuValue.selectedSkuComb !== null) {
              this.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
            }
            break
          }
        }
      } else {
        if (this.listItem.sales_low_price != this.listItem.sales_high_price) {
          this.skuprice =
            parseFloat(this.listItem.sales_low_price).toFixed(2) +
            '-' +
            parseFloat(this.listItem.sales_high_price).toFixed(2)
        } else {
          this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2)
        }
      }
    },
    onConfirmClicked() {
      let that = this,
        skuData = this.$refs.sku.getSkuData(),
        datas

      if (!skuData.selectedSkuComb) {
        return
      }
      datas = {
        skuid: this.listItem.skuid,
        num: this.productNum,
        new_skuid: skuData.selectedSkuComb.id
      }
      if (skuData.selectedSkuComb.id !== this.listItem.skuid) {
        this.updateProduct(datas, function() {
          that.$nextTick(function() {
            that.initialSku = skuData.selectedSkuComb
            that.initialSku['selectedNum'] = skuData.selectedNum
          })
          that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
          that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          that.list[that.itemIndex].spec = that.skuname
          that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
          that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
          that.list[that.itemIndex].temp_sales_price = skuData.selectedSkuComb.temp_sales_price
          that.list[that.itemIndex].changebuystatus = skuData.selectedSkuComb.changebuystatus
          if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
            that.productNum = skuData.selectedSkuComb.stock_num
          }
          that.list[that.itemIndex].num = that.productNum
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          if (
            that.list[that.itemIndex].islimit != 0 ||
            parseInt(that.list[that.itemIndex].canbuycnt) <= 0 ||
            that.list[that.itemIndex].issale == 0
          ) {
            that.list[that.itemIndex].ischoose = 0
          } else {
            that.count()
          }
        })
      }
      this.showsku = false
    },
    // 选择/取消选择
    choice(item) {
      item.ischoose = item.ischoose ? 1 : 0
      this.count()
    },
    // 全选/取消全选
    Allchoice() {
      this.allChoiceFlag = this.allChoiceFlag ? 1 : 0
      if (!this.allChoiceFlag) {
        this.list.forEach(function(item) {
          item.ischoose = 0
        })
      } else {
        this.list.forEach(function(item) {
          item.ischoose = 1
        })
      }
      this.count()
    },
    // 商品数量加减
    addToCart(type, index, item) {
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt)
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
      } else {
        if (num <= 1) {
          this.$toast('不能再减了')
          return
        }
        num += -1
      }
      this.list[index].num = num
      this.count()
    },

    fullDiscountRuleFn: function() {
      let chooselen = 0,
        that = this
      that.fullDiscountmoney = 0
      that.list.map((item) => {
        if (item.ischoose && item.isFullDiscount == 1) chooselen += parseInt(item.num)
      })
      if (that.fullDiscountRule.rulelist && chooselen > 0) {
        let rulelist = that.fullDiscountRule.rulelist
        for (let i = 0; i < rulelist.length; i++) {
          if (chooselen >= parseInt(rulelist[i].num)) {
            that.list.map((listitem) => {
              if (
                (listitem.ischoose == true || listitem.ischoose == 1) &&
                listitem.isFullDiscount == 1
              ) {
                listitem.fullDiscountPrice =
                  parseFloat(listitem.sales_price) -
                  parseFloat(listitem.cost_price) * parseFloat(rulelist[i].discount)
                that.fullDiscountmoney += listitem.fullDiscountPrice * listitem.num
              } else {
                listitem.fullDiscountPrice = 0
              }
            })
            break
          } else if (i == rulelist.length - 1) {
            that.fullDiscountmoney = 0
            that.list.map((listitem) => {
              listitem.fullDiscountPrice = 0
            })
          }
        }
      }
      console.log(this.list)
    },
    // 计算合计金额
    count() {
      this.fullDiscountRuleFn()
      let list = this.list,
        totalNumber = 0,
        totalMoney = 0,
        oldTotalMoney = 0,
        count = 0,
        goodsnum = 0,
        money = 0,
        countTotalMoney = 0

      for (let i in list) {
        if (list[i].ischoose) {
          count += 1
          totalNumber += parseInt(list[i].num)
          totalMoney += list[i].num * list[i].sales_price
          countTotalMoney += list[i].num * list[i].sales_price
          oldTotalMoney += list[i].num * list[i].cost_price
          if (list[i].isdiscount == 1) {
            goodsnum += parseInt(list[i].num)
            money += list[i].sales_price * list[i].num + parseFloat(list[i].changebuy_price || 0)
          }
        }
      }
      this.allChoiceFlag = count === list.length ? 1 : 0
      this.totalNumber = totalNumber
      totalMoney = totalMoney - this.fullDiscountmoney
      this.totalMoney = totalMoney.toFixed(2)
      this.countTotalMoney = countTotalMoney.toFixed(2)
      this.oldTotalMoney = oldTotalMoney.toFixed(2)
      this.money = money
      this.goodsnum = goodsnum
      this.handleDiscountData()
    },
    // 处理优惠数据
    handleDiscountData() {
      let that = this,
        discountlist,
        discount,
        txt,
        txt1,
        discount1,
        discount2
      // 折上折
      if (this.discountrule && this.discountrule.discountenable == 1) {
        discountlist = this.discountrule.discountlist

        if (parseInt(this.goodsnum) == 0) {
          discount = discountlist[0].discount
          txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
          this.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
          this.currentdiscount = 1
        } else if (parseInt(this.goodsnum) >= parseInt(discountlist[0].itemnum)) {
          discount = discountlist[0].discount
          txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
          if (this.fullgiftrule.actstatus && parseInt(this.fullgiftrule.actstatus) == 1) {
            this.FlodMsg = ''
          } else {
            this.FlodMsg = '惊喜！已选' + this.goodsnum + '件享' + txt + '折'
          }
          this.currentdiscount = discount
        } else if (
          parseInt(this.goodsnum) < parseInt(discountlist[discountlist.length - 1].itemnum)
        ) {
          discount1 = discountlist[discountlist.length - 1].discount
          txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
          this.FlodMsg =
            '惊喜！已选' +
            this.goodsnum +
            '件，再加' +
            (parseInt(discountlist[discountlist.length - 1].itemnum) - this.goodsnum) +
            '件即可享受' +
            txt +
            '折。'
          this.currentdiscount = 1
        } else {
          try {
            discountlist.forEach(function(item, index) {
              if (parseInt(that.goodsnum) >= parseInt(item.itemnum)) {
                discount1 = item.discount
                discount2 = discountlist[index - 1].discount
                txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
                txt1 = (discount2 * 100) % 10 == 0 ? (discount2 * 100) / 10 : discount2 * 100
                that.FlodMsg =
                  '惊喜！已选' +
                  that.goodsnum +
                  '件享' +
                  txt +
                  '折，再加' +
                  (parseInt(discountlist[index - 1].itemnum) - that.goodsnum) +
                  '件即可享受' +
                  txt1 +
                  '折。'
                that.currentdiscount = discount1
                throw new Error()
              }
            })
          } catch (e) {}
        }
      }

      // 满赠
      if (this.fullgiftrule && this.fullgiftrule.actstatus == 1 && !this.FlodMsg) {
        let rulelist = this.fullgiftrule.rulelist,
          price = 0,
          m,
          m1

        if (rulelist.length) {
          this.list.forEach(function(item) {
            if (item.ischoose) {
              if (item.isfullgift == 1) {
                if (parseInt(item.isdiscount) == 1 && that.currentdiscount > 0) {
                  price +=
                    Number(item.sales_price) * parseInt(item.num) * Number(that.currentdiscount)
                } else {
                  price += Number(item.sales_price) * parseInt(item.num)
                }
              }
            }
          })
          this.currentfullgiftmoney = parseFloat(price).toFixed(2)

          if (!isNaN(Number(this.currentfullgiftmoney))) {
            if (
              parseFloat(this.currentfullgiftmoney) == 0 ||
              parseFloat(this.currentfullgiftmoney) <
                parseFloat(rulelist[rulelist.length - 1].allmoney)
            ) {
              m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
                ? parseFloat(
                    Number(rulelist[rulelist.length - 1].allmoney) -
                      Number(this.currentfullgiftmoney)
                  ).toFixed(2)
                : '0.00'
              m1 = !isNaN(parseFloat(rulelist[rulelist.length - 1].senditemprice))
                ? parseFloat(rulelist[rulelist.length - 1].senditemprice).toFixed(2)
                : '0.00'
              this.FullGiftMsg =
                '惊喜！还差<span>' +
                m +
                '</span>元，即送价值<span>' +
                (parseFloat(m1) > 0
                  ? m1
                  : parseFloat(rulelist[rulelist.length - 1].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[rulelist.length - 1].senditemname
            } else if (parseFloat(this.currentfullgiftmoney) >= parseFloat(rulelist[0].allmoney)) {
              m = !isNaN(parseFloat(rulelist[0].allmoney))
                ? parseFloat(rulelist[0].allmoney).toFixed(2)
                : '0.00'
              m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
                ? parseFloat(rulelist[0].senditemprice).toFixed(2)
                : '0.00'
              this.FullGiftMsg =
                '惊喜！已满<span>' +
                m +
                '</span>元，可领价值<span>' +
                (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[0].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[0].senditemname
            } else {
              try {
                rulelist.forEach(function(item, index) {
                  if (parseFloat(that.currentfullgiftmoney) >= parseFloat(item.allmoney)) {
                    m = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                      ? parseFloat(
                          Number(rulelist[index - 1].allmoney) - Number(that.currentfullgiftmoney)
                        ).toFixed(2)
                      : '0.00'
                    m1 = !isNaN(parseFloat(rulelist[index - 1].senditemprice))
                      ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg =
                      '惊喜！还差<span>' +
                      m +
                      '</span>元，即送价值<span>' +
                      (parseFloat(m1) > 0
                        ? m1
                        : parseFloat(rulelist[index - 1].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index - 1].senditemname
                    throw new Error()
                  }
                })
              } catch (e) {}
            }
          }
        }
      }

      this.discounmoney = 0
      if (this.money > 0 && this.currentdiscount > 0) {
        this.discounmoney = this.money * (1 - this.currentdiscount)
        this.totalMoney = parseFloat(this.totalMoney) - parseFloat(this.discounmoney)
        console.log(this.totalMoney, this.discounmoney)
      }
    },
    // 提交商品
    submit() {
      let shopConfirmResult,
        ispresale = 0
      this.$app.argFunc(() => {
        if (!isWeixin()) {
          if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
            this.$store.commit('PATH_VALUE', JSON.stringify({ id: this.$route.query.id }))
            this.$router.push({
              path: '/login',
              query: {
                routeval: 'bspl'
              }
            })
          }
        }
      })

      shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        skuidArrOversea: [],
        from: 2,
        orderfrom: 2,
        itemNumOversea: [],
        totalmoney: parseFloat(this.totalMoney) + this.fullDiscountmoney,
        totalnum: this.totalNumber,
        liveId: [],
        roomId: [],
        LiveIdArrOversea: [],
        roomIdArrOversea: [],
        beautityitemid: this.$route.query.beautitysaidid
      }
      if (this.$route.query.source) shopConfirmResult.source = this.$route.query.source
      this.list.forEach(function(item) {
        if (item.ischoose) {
          if (item.isoversea == 1) {
            shopConfirmResult.skuidArrOversea.push(item.skuid)
            shopConfirmResult.itemNumOversea.push(item.num)
            shopConfirmResult.LiveIdArrOversea.push(item.live_id)
            shopConfirmResult.roomIdArrOversea.push(item.room_id)
          } else {
            shopConfirmResult.skuidArr.push(item.skuid)
            shopConfirmResult.itemNum.push(item.num)
            shopConfirmResult.liveId.push(item.live_id)
            shopConfirmResult.roomId.push(item.room_id)
          }
          if (item.ispresale == 1) {
            ispresale = 1
          }
        }
      })

      if (!shopConfirmResult.skuidArr.length && !shopConfirmResult.skuidArrOversea.length) {
        this.$toast('请选择要结算的商品')
        return
      }
      if (this.showPresale == false && ispresale == 1 && !localStorage.getItem('itemcartpresale')) {
        this.showPresale = true
        localStorage.setItem('itemcartpresale', '1')
      } else {
        if (shopConfirmResult.skuidArr.length && !shopConfirmResult.skuidArrOversea.length) {
          this.checkOrder(shopConfirmResult)
        } else if (shopConfirmResult.skuidArrOversea.length && !shopConfirmResult.skuidArr.length) {
          // 为了使普通商品和海外商品的确认订单接口参数key值保持一致
          shopConfirmResult.skuidArr = shopConfirmResult.skuidArrOversea
          shopConfirmResult.itemNum = shopConfirmResult.itemNumOversea
          shopConfirmResult.liveId = shopConfirmResult.LiveIdArrOversea
          shopConfirmResult.roomId = shopConfirmResult.roomIdArrOversea
          shopConfirmResult.skuidArrOversea = []
          shopConfirmResult.itemNumOversea = []
          shopConfirmResult.LiveIdArrOversea = []
          shopConfirmResult.roomIdArrOversea = []
          this.checkOrder(shopConfirmResult)
        } else {
          this.$toast('海外商品不能与普通商品一起购买')
        }
      }
    },

    // 检查订单状态
    checkOrder(shopConfirmResult) {
      let urlCheck =
        this.$ajax.checkOrder_URL +
        '?skuids=' +
        shopConfirmResult.skuidArr.join() +
        '&buynum=' +
        shopConfirmResult.itemNum.join()
      this.$customRequestAjax(urlCheck).then((res) => {
        if (res.data.code == 200) {
          before_addOrder(shopConfirmResult)
          this.dataCollection()
          this.$app.addToConfirmOrder(shopConfirmResult, '', {
            beautityitemid: this.$route.query.beautitysaidid
          })
        } else {
          this.$toast(res.data.msg)
        }
      })
    },
    dataCollection() {
      let list = this.list
      for (let i in list) {
        if (list[i].ischoose) {
          let params = {
            productId_var: list[i].itemid, // 商品id
            productName_var: list[i].name, // 商品名称
            firstCat_var: '', // 商品一级分类
            productType_var: '', // 商品品类
            productFormat_var: list[i].skuid, // 商品规格
            buyQuantity_var: list[i].num, // 购买数量
            payAmount_var: (list[i].sales_price * list[i].num).toFixed(2) // 支付金额
          }
          gio('track', 'settleProduct', params)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.van-icon-arrow-down {
  margin-left: 0.04rem;
}
.flex-js-ac {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-ac {
  display: flex;
  align-items: center;
}
.mt18 {
  margin-top: 0.18rem;
}
.ml10 {
  margin-left: 0.1rem;
}
.ml20 {
  margin-left: 0.2rem;
}
.f16 {
  font-size: 0.16rem;
}
.list {
  margin: 0.1rem 0.1rem 0;
  font-size: 0.12rem;
  padding-bottom: 0.7rem;
  .item {
    margin-bottom: 0.1rem;
    padding: 0.16rem 0.1rem;
    background: #fff;
    .productInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.14rem;
      padding-bottom: 0.12rem;
      color: #242424;
      line-height: 0.2rem;
      font-weight: 400;
    }
    img {
      margin: 0 0.08rem;
      width: 0.8rem;
      height: 0.8rem;
    }
    .rightBox {
      flex: 1;
      height: 0.8rem;
      font-size: 0.12rem;
      .name {
        width: 2.1rem;
        font-size: 0.14rem;
        color: #292929;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .sku {
        margin-top: 0.08rem;
        color: #6c6c6c;
        font-size: 0.12rem;
        span {
          border-radius: 0.1rem;
          padding: 0.02rem 0.08rem;
          background: #f6f6f6;
        }
      }
      .currentPrice {
        color: #fc0324;
        font-size: 0.14rem;
        font-weight: bold;
      }
      .stepBox {
        width: 0.86rem;
        height: 0.22rem;
        border: 1px solid #e5e5e5;
        text-align: center;
        border-radius: 0.14rem;
        .add,
        .subtract {
          width: 0.24rem;
          height: 100%;
        }

        .subtract {
          background: url(../../../static/images/productList/icon-subtract.png) no-repeat;
          background-size: 0.09rem;
          background-position: 0.06rem 0.05rem;
          &.can {
            background: url(../../../static/images/productList/icon-subtract-disabled.png) no-repeat;
            background-size: 0.09rem;
            background-position: 0.06rem 0.05rem;
          }
        }

        .add {
          background: url(../../../static/images/productList/icon-add-disabled.png) no-repeat;
          background-size: 0.09rem;
          background-position: 0.06rem 0.05rem;
          &.can {
            background: url(../../../static/images/productList/icon-add.png) no-repeat;
            background-size: 0.09rem;
            background-position: 0.06rem 0.05rem;
          }
        }
        .num {
          width: 0.36rem;
          height: 100%;
          background: #eeeff4;
          color: #333;
        }
      }
    }
    .act_desc_tag {
      font-size: 0.12rem;
      margin-top: 0.08rem;
      margin-left: 0.25rem;
      .van-icon-arrow {
        float: right;
      }
    }
    .act_desc_time {
      font-size: 0.11rem;
      margin-left: 0.18rem;
      color: #f12a0e;
      margin-top: 0.04rem;
      display: flex;
      align-items: center;
      img {
        width: 0.12rem;
        height: 0.12rem;
      }
      .txt {
        font-size: 0.12rem;
        color: #f12a0e;
        transform: scale(0.92, 0.92);
        margin-left: -0.03rem;
        line-height: 0.17rem;
      }
    }
  }
}
.btnBox {
  z-index: 2001;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 0.24rem;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.12rem;
  background: #fff;
  border-top: 0.01rem solid #ccc;
  p {
    line-height: 0.2rem;
  }
  .submitBtn {
    width: 1.1rem;
    height: 0.38rem;
    line-height: 0.38rem;
    background: linear-gradient(to right, #fc0324, #ff144f);
    border-radius: 0.2rem;
    font-size: 0.16rem;
    color: #fff;
    text-align: center;
  }
}
.presale_info_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .dialog {
    width: 79%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.04rem;
    height: 2.24rem;
    position: relative;
    .header {
      width: 70%;
      margin: 0 auto;
      font-weight: bold;
      .van-divider {
        display: flex;
        align-items: center;
        margin: 0.2rem 0;
        line-height: 0.24rem;
        border-color: #666666;
        border-style: solid;
        border-width: 0;
        color: #333333;
        font-size: 0.21rem;
      }
      .van-divider::before,
      .van-divider::after {
        content: ' ';
        display: block;
        flex: 1;
        box-sizing: border-box;
        height: 1px;
        border-color: inherit;
        border-style: inherit;
        border-width: 0 0 0;
        margin-right: 0.16rem;
        margin-left: 0.16rem;
      }
    }

    .content {
      width: 80%;
      margin: 0 auto;
      text-align: center;
      color: #444444;
      font-size: 0.14rem;
      margin-top: 0.02rem;
      line-height: 0.2rem;
      height: 1.2rem;
      overflow-y: auto;
    }
    .btn {
      background: #fc0324;
      width: 50%;
      text-align: center;
      color: #fff;
      font-size: 0.15rem;
      border-radius: 0.16rem;
      height: 0.31rem;
      line-height: 0.31rem;
      position: absolute;
      left: 25%;
      bottom: 0.22rem;
    }
  }
}
.offerdetailsdis {
  .ofd1 {
    font-size: 0.12rem;
    color: #3d3d3d;
    text-align: center;
    line-height: 0.17rem;
    margin-top: 0.18rem;
    margin-bottom: 0.2rem;
  }
  .discountList {
    padding: 0.15rem 0.15rem 0.5rem;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.14rem;
      padding-bottom: 0.12rem;
      color: #242424;
      line-height: 0.2rem;
      font-weight: 400;
    }

    .goodstotalprice {
      color: #242424;
      font-weight: 600;
    }
    .combined {
      font-size: 0.16rem;
      color: #fc0324;
      line-height: 0.22rem;
      font-weight: 400;
    }
    .desc {
      color: #3d3d3d;
      font-size: 0.12rem;
      line-height: 0.17rem;
      padding-bottom: 0.3rem;
    }
  }
}
.discountWrap {
  z-index: 2000;
  position: fixed;
}
.van-action-sheet__close {
  background: url('../../assets/images/closex.png') center no-repeat;
  background-size: 0.2rem 0.2rem;
}
.oldTotalMoney {
  margin-right: 0.04rem;
  font-size: 0.12rem;
  color: #888;
  text-decoration: line-through;
}
.discountLabel {
  font-size: 0.12rem;
}
.foldBtn {
  width: 0.12rem;
  height: 0.12rem;
}
.color-red {
  color: #ff144f;
}
.f16 {
  font-size: 0.16rem;
}
.fb {
  font-weight: 700;
}

.homeBtn {
  z-index: 10;
  position: fixed;
  right: 0.17rem;
  bottom: 1.2rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 0.4rem;
    height: 0.4rem;
    display: block;
  }
}
.homeBtn.fullgift {
  bottom: 0.7rem;
}
</style>
<style lang="scss">
.recommendProducts {
  .additemMsg .txt span {
    color: #ff253e;
  }
  .shop {
    .good_sku {
      .van-icon-cross {
        background: url('../../assets/images/close3.png') no-repeat center;
        background-size: 100%;
        color: transparent;
      }
    }
  }

  .van-checkbox__icon {
    height: auto !important;
  }
  .van-checkbox {
    .van-checkbox__label {
      line-height: 0.2rem;
    }
  }
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
    font-size: 0.11rem;
  }
  .PriceAndNum .van-stepper__input {
    width: 0.35rem;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
  .pro_details_con {
    font-size: 0.14rem;
  }
  .pro_details_con img {
    width: 100% !important;
    height: auto !important;
  }
  .pro_details_con .ckeditor-html5-video {
    width: 100%;
  }
  .pro_details_con .ckeditor-html5-video video {
    width: 100%;
  }
  .van-sku-stepper-stock {
    display: none;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }
  .van-sku-actions .van-button--danger.sure {
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  }

  .van-action_model {
    height: 70vh;
    .van-item {
      padding: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      .vanbtn {
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
        border-radius: 0.25rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/productList.vue